import { z } from "zod";

const errorMessages = {
  required: "وارد کردن این فیلد اجباری است",
};

const schema = z.object({
  application_status: z.string().min(1, errorMessages.required),
  application_message: z.string().optional().default(""),
});

export { schema };
